import React, { createContext } from 'react';
import config from '../config/config.json';
import Config from '../config/Config';
import { APP_QUERY_PARAMS } from 'utils/queryParam.utils';

const defaultConfig = config.dev;
const environment = process.env.REACT_APP_DEPLOYMENT_ENV || 'dev';
const environmentConfig = config[environment];
const finalConfig = {
  ...defaultConfig,
  ...environmentConfig,
  appQueryParams: APP_QUERY_PARAMS,
  userRoles: ['Editor', 'Admin'],
};

const ConfigContext = createContext(null);
const ConfigConsumer = ConfigContext.Consumer;
const configInstance = new Config(finalConfig);

const ConfigProvider = ({ children }) => (
  <ConfigContext.Provider value={{ config: configInstance }}>{children}</ConfigContext.Provider>
);

export { ConfigProvider, ConfigConsumer, configInstance };

export default ConfigContext;
